import React from "react";
import DefaultInvoice from "./DefaultInvoice";
import Invoice1 from "./Invoice1";
import Invoice2 from "./Invoice2";
import Invoice3 from "./Invoice3";
import Invoice3WithVat from "./Invoice3WithVat";
import KOT from "./KOT";

function InvoiceMain({ setting, invoiceDetails }) {
  const invoiceSetting = JSON.parse(
    setting.filter((set) => set.type === "invoice_settings")[0].value
  );
  const logo = JSON.parse(
    setting.filter((set) => set.type === "logo")[0].value
  );
  const general = JSON.parse(
    setting.filter((set) => set.type === "general")[0].value
  );

  if (invoiceSetting.invoice === "Default") {
    return (
      <>
        <DefaultInvoice
          logo={logo.logo_image_url}
          general={general}
          data={invoiceDetails}
          invoice={invoiceSetting}
        />
        <div className="page-break" />
        <KOT data={invoiceDetails} />
      </>
    );
  }
  if (invoiceSetting.invoice === "Invoice 1") {
    return (
      <>
        <Invoice1
          logo={logo.logo_image_url}
          general={general}
          data={invoiceDetails}
          invoice={invoiceSetting}
        />
        <div className="page-break" />
        <KOT data={invoiceDetails} />
      </>
    );
  }
  if (invoiceSetting.invoice === "Invoice 2") {
    return (
      <>
        <Invoice2
          logo={logo.logo_image_url}
          general={general}
          data={invoiceDetails}
          invoice={invoiceSetting}
        />
        <div className="page-break" />
        <KOT data={invoiceDetails} />
      </>
    );
  }
  if (invoiceSetting.invoice === "Invoice 3") {
    return (
      <>
        <Invoice3
          logo={logo.logo_image_url}
          general={general}
          data={invoiceDetails}
          invoice={invoiceSetting}
        />
        <div className="page-break" />
        <KOT data={invoiceDetails} />
      </>
    );
  }
  if (invoiceSetting.invoice === "Invoice 3 with VAT") {
    return (
      <>
        <Invoice3WithVat
          logo={logo.logo_image_url}
          general={general}
          data={invoiceDetails}
          invoice={invoiceSetting}
        />
        <div className="page-break" />
        <KOT data={invoiceDetails} />
      </>
    );
  }
}

export default InvoiceMain;
